

import React, { useEffect, useState } from "react";
// import "./MobileSlider.css";
import "./TravelAndAdvSlider.css"
import { Select } from "antd";
import { Citys, cities, location1 } from "../../component/Location";
import { Mobiles, TravelAndAdventure } from "../../component/env";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getExtraField } from "../../store/ProductFilterSlice";
const images = [
    "https://img.freepik.com/free-vector/travel-concept-with-landmarks_1057-4873.jpg?t=st=1735555371~exp=1735558971~hmac=19756a63cee251086217f75d5ed440fa830dd5c543f442c56280d5db109d0561&w=740",
    "https://img.freepik.com/free-photo/top-view-travel-elements-collection_23-2148691085.jpg?t=st=1735619756~exp=1735623356~hmac=fc83d142c8be9e0f240c3f6cf933545d69a6945d907c0edc812ca38bc15ff26e&w=996",
    "https://img.freepik.com/free-photo/beautiful-girl-standing-viewpoint-koh-nangyuan-island-near-koh-tao-island-surat-thani-thailand_335224-1094.jpg?t=st=1735555456~exp=1735559056~hmac=f2de1a4e121947753d0ead6ba8a9d3647277c98215bada727919cf0062e445d3&w=900",
    "https://img.freepik.com/free-photo/suitcase-with-traveler-accessories_1150-17822.jpg?t=st=1735555510~exp=1735559110~hmac=6ac3e928f5e41263c282335ff6eaf40f505c8f94da94b89c06be60ac5f9a75fb&w=900",
    "https://img.freepik.com/free-photo/travel-supplies-around-passports_23-2147801006.jpg?t=st=1735555597~exp=1735559197~hmac=99b6fc37229b2f62edeb4450fc88ddf7d06a25790edf7ee86b4ad4aec45ef61d&w=900",
    "https://img.freepik.com/free-photo/christmas-travel-concept-with-luggage_23-2149575605.jpg?uid=R181024013&ga=GA1.1.1621696285.1734418691&semt=ais_hybrid"
];

const TravelAndAdvSlider = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visible1, setVisible1] = useState(false);
    const handleDropdownVisibleChange = (open) => {
        setVisible1(open);
    };
    const [visible2, setVisible2] = useState(false);
    const handleDropdownVisibleChange2 = (open) => {
        setVisible2(open);
    };
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000);
        return () => clearInterval(interval);
    }, [images.length]);

    const mobilestyle = {
        height: "200px",
        width: "100%",
    };
    const desktopstyle = {
        height: "340px",
        width: "90%",
        marginLeft: "1.5cm",
        marginRight: "2.5cm",
        borderRadius: "20px",
    };
    const mobstyle = {
        display: "flex",
        flexDirection: "column",
    };
    const deskstyle = {
        display: "flex",
        flexDirection: "row",
    };

    const [selectedFilter, setSelectedFilter] = useState(null);

    const [loading, setLoading] = useState(false); // Setting up a state variable 'loading' and its setter function 'setLoading' with initial value 'false'
    const disptach = useDispatch();
    const dispatch = useDispatch();
    // Accessing the Redux dispatch function
    const [errorMessage, setErrorMessage] = useState(null);
    const [extraFieldCopy, setExtraFieldCopy] = useState({});
    const [city, setCity] = useState();
    const [category, setCategory] = useState();
    const [cityError, setCityError] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [searchSending, setsearchSending] = useState({
        subCategoryType: null,
        subCategoryValue: null,
        City: null,
        searchValue: null,
        category: "TravelAndAdventure",
        minPrice: null,
        maxPrice: null,
    }); // State for search form data

    //   const disptach = useDispatch(); // Initializing useDispatch hook

    // Event handler for input field changes
    const handleChange = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        setExtraFieldCopy({ [name]: value });
        // setsearchSending({ ...searchSending, [name]: value });
        // disptach(getExtraField(searchSending)); // Dispatching getExtraField action
    };

    useEffect(() => {
        // Update searchSending state with the selected filter value
        if (selectedFilter !== null) {
            setsearchSending((prevState) => ({
                ...prevState,
                category: selectedFilter,
            }));
        }
    }, [selectedFilter]);
    return (
        <>
            <div
                className="travelslide travelslide-awi-24 mt-4 mb-3"
            // style={isMobile ? mobstyle : deskstyle}
            >
                <div className="search-form-awi-25">
                    <h1
                        style={{
                            fontSize: "20px",
                            fontFamily: "times",
                            borderBottom: "1px double white",
                            borderTop: "1px double white",
                            fontWeight: "bold",
                            color: "brown",
                        }}
                    >
                        SEARCH FOR TRAVEL AND ADVENTURE
                    </h1>
                    <div className="form-group1 mt-3">
                        <h6
                            style={{
                                fontFamily: "verdana",
                                color: "gray",
                                fontWeight: "bold",
                                fontSize: "14px",
                            }}
                        >
                            Select City :
                        </h6>
                        <Select
                            open={visible1}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{
                                width: "15rem",
                                padding: "5px 0px",
                            }}
                            placeholder="Select City"
                            onChange={(value) => setCity(value)}
                            options={Citys.map((value) => ({
                                value: value,
                                label: value,
                            }))}
                            showSearch={true}
                            filterOption={(inputValue, option) =>
                                option.label.toLowerCase().includes(inputValue.toLowerCase())
                            }
                        />
                        {cityError && <p className="error-message">{cityError}</p>}
                    </div>
                    <div className="form-group1">
                        <h6
                            style={{
                                fontFamily: "verdana",
                                color: "gray",
                                fontWeight: "bold",
                                fontSize: "14px",
                            }}
                        >
                            Select Category :
                        </h6>
                        <Select
                            open={visible2}
                            onDropdownVisibleChange={handleDropdownVisibleChange2}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{ width: "15rem" }}
                            placeholder="select category"
                            value={category || null}
                            onChange={(value) => setCategory(value)}
                            options={TravelAndAdventure.map((value) => ({
                                value: value,
                                label: value,
                            }))}
                        />
                        {categoryError && <p className="error-message">{categoryError}</p>}
                    </div>
                    <Link
                        to={`/ads-listing/`}
                        onClick={(e) => {
                            if (!city || !category) {
                                e.preventDefault(); // Prevent the default navigation behavior
                                console.log("Please select both City and Category.");
                                setErrorMessage("Please select both City and Category."); // Set an error message
                            } else {
                                setErrorMessage(null); // Clear any previous error message

                                for (const key in searchSending) {
                                    if (
                                        searchSending[key]?.trim() === "" ||
                                        searchSending[key] === null
                                    ) {
                                        delete searchSending[key];
                                    }
                                }
                                searchSending["extraField"] = { ...extraFieldCopy };
                                searchSending["subCategoryValue"] = category;
                                searchSending["City"] = city;
                                disptach(getExtraField(searchSending));
                            }
                        }}
                    >
                        <button className="buttonno11">Search</button>
                    </Link>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                </div>

                <div className="carousel-inner24-awi-25">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className={`carousel-item${index === activeIndex ? " active" : ""
                                }`}
                        >
                            <img
                                src={image}
                                alt={`Slide ${index}`}
                                style={isMobile ? mobilestyle : desktopstyle}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};
export default TravelAndAdvSlider;
